export class MedicalRecordSectionConfig {
    id = null;
    name = null;
    code = null;
    description = null;
}